import { ElementRef, OnInit, Input, HostBinding } from '@angular/core';
import { Directive } from '@angular/core';
import { FontTypeEnum } from '../model/enums/FontTypeEnum';
import { SessionService } from '../session-service.service';

@Directive({
  selector: '[appConfigSettingsPrimaryButton]'
})
export class ConfigSettingsPrimaryButtonDirective implements OnInit {

  FontTypeEnum = FontTypeEnum;
  isBackgroundColorManagedByHostBinding = false;
  backgroundDisabledColor = 'rgb(201, 201, 201)';

  constructor(private elementRef: ElementRef, private sessionService: SessionService) { }

  @Input()
  @HostBinding('attr.disabled') set disabled(disabled: boolean) {
    this.elementRef.nativeElement.style.backgroundColor = disabled ?
      this.backgroundDisabledColor :
      this.sessionService.getConfigSettingsDto().backgroundColor;
    this.isBackgroundColorManagedByHostBinding = true;
  }

  ngOnInit(): void {
    this.elementRef.nativeElement.style.color = this.sessionService.getConfigSettingsDto().backgroundTextColor;
    this.elementRef.nativeElement.style.fontFamily = FontTypeEnum[this.sessionService.getConfigSettingsDto().fontType] || FontTypeEnum.Sun;
    if (!this.isBackgroundColorManagedByHostBinding) {
      this.elementRef.nativeElement.style.backgroundColor = this.sessionService.getConfigSettingsDto().backgroundColor;
    }
  }
}
